import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import { CommonService } from '@app/shared-module/common-service.service';
import { Constants } from '@app/shared-module/constants';
import { Clinic, GlobalResponse, User } from '@app/shared-module/models';
import { IMyDrpOptions } from 'mydaterangepicker';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import { AdminService } from '../../services/admin.service';
import { UpdatePaymentComponent } from '../update-payment/update-payment.component';

@Component({
  selector: 'app-repayment-details',
  templateUrl: './repayment-details.component.html',
  styleUrls: ['./repayment-details.component.scss']
})
export class RepaymentDetailsComponent implements OnInit {
  user: User;
  isEditEnabled = false;
  selectedClinicID = '';
  repaymentList: any[] = [];
  length = 0;
  pageSize = 10;
  pageNumber = 0;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  dateRange: any;
  currentDate: Date = new Date();
  previousMonthDate: Date;
  clinicList: Clinic[] = [];
  clinic_selected: any;
  @BlockUI() blockUI: NgBlockUI;
  myDateRangePickerOptions: IMyDrpOptions = {
    dateFormat: Constants.DATE_FORMAT,
    disableSince: { year: this.currentDate.getFullYear(), month: this.currentDate.getMonth() + 1, day: this.currentDate.getDate() + 1 },
    showClearDateRangeBtn: false,
    editableDateRangeField: false,
    openSelectorOnInputClick: true
  };

  updatePayementDialog: MatDialogRef<UpdatePaymentComponent>;

  constructor(
    public dialog: MatDialog,
    private adminSrv: AdminService,
    private commonService: CommonService,
    private datePipe: DatePipe,
    private toastr: ToastrService
  ) {
    this.previousMonthDate = new Date(this.currentDate);
    this.previousMonthDate.setMonth(this.previousMonthDate.getMonth() - 1);
    // console.log(this.previousMonthDate);
    this.dateRange = {
      beginDate: { year: this.previousMonthDate.getFullYear(), month: this.previousMonthDate.getMonth() + 1, day: this.previousMonthDate.getDate() },
      endDate: { year: this.currentDate.getFullYear(), month: this.currentDate.getMonth() + 1, day: this.currentDate.getDate() }
    };
  }

  ngOnInit() {
    this.getClinicList();
    this.user = this.commonService.internalLoginValue;
    if (this.user && this.user.role && (this.user.role === Constants.ROLE_ADMIN || this.user.role === Constants.ROLE_ACCOUNTS)) {
      this.isEditEnabled = true;
    } else {
      this.isEditEnabled = false;
    }
  }

  updatePayment(item: any) {
    this.updatePayementDialog = this.dialog.open(UpdatePaymentComponent, {
      disableClose: false
    });
    this.updatePayementDialog.componentInstance.headerTitle = 'Update Payment';
    this.updatePayementDialog.componentInstance.itemId = item._id;
    this.updatePayementDialog.componentInstance.paidAmount = Number(item.total_online_due);

    this.updatePayementDialog.afterClosed().subscribe(result => {
      if (result) {
        this.fetchRepaymentList();
      }
      this.updatePayementDialog = null;
    });
  }

  changeDate(event: any) {
    // console.log(event);
    // console.log(this.dateRange);
    if (event) {
      this.dateRange = event;
    }
    this.fetchRepaymentList();
  }

  pageEvent(event) {
    // console.log(this.pageSize);
    this.pageNumber = event.pageIndex;
    this.pageSize = event.pageSize;
    this.fetchRepaymentList();
  }

  fetchRepaymentList() {
    this.blockUI.start();
    this.adminSrv.getRepaymentDetails(this.dateRange.beginDate, this.dateRange.endDate, this.pageSize, this.pageNumber, this.selectedClinicID).subscribe(
      (res: GlobalResponse) => {
        this.blockUI.stop();
        if (res && res.message && res.message === Constants.STATUS_SUCCESS) {
          // console.log(res.result);
          this.repaymentList = res.result.clinicPayment;
          // this.subscriptionCount = res.result.doctorSubscriptionCount;
          this.length = res.result.clinicPaymentCount;
        }
      },
      (error: any) => {
        this.toastr.error(error);
      });
  }

  getClinicList() {
    this.blockUI.start();
    this.adminSrv.getClinicList()
      .subscribe((res: GlobalResponse) => {
        this.blockUI.stop();
        if (res && res.message && res.message === Constants.STATUS_SUCCESS) {
          this.clinicList = res.result;
          if (this.clinicList && this.clinicList.length > 0) {
            this.clinic_selected = this.clinicList[0];
            this.selectedClinicID = this.clinic_selected._id;
            this.fetchRepaymentList();
          }
          // console.log(this.clinicList);
        }
      });
  }

  onClinicChange = event => {
    if (this.clinic_selected && this.clinic_selected.name && this.clinic_selected.name !== undefined) {
      this.selectedClinicID = this.clinic_selected._id;
      this.fetchRepaymentList();
    }
  }

  exportAsXLSX(): void {
    const header = {
      header: ['Date', 'Clinic', 'Online Transaction Amount', 'Online Pending Amount', 'Phone Call Amount', 'Phone Call Amount to be paid', 'Total Amount to be paid', 'Amount Paid']
    };
    // const header = ['Doctor', 'Clinic', 'Trial End Period', 'Plan', 'Payment Date', 'Amount Paid', 'Subscription End Date'];
    const tempArray = [];
    for (const item of this.repaymentList) {
      const tempItem: any = {} as any;
      tempItem.clinic_name = item.clinic.name;
      tempItem.total_online_amount = item.total_online_amount;
      tempItem.online_due = item.online_due;
      tempItem.total_phone_consultation_amount = item.total_phone_consultation_amount;
      tempItem.total_phone_consultation_due = item.total_phone_consultation_due;
      tempItem.total_online_due = item.total_online_due;
      tempItem.paid_amount = item.paid_amount;
      tempItem.date = this.datePipe.transform(item.date, 'yyyy-MM-dd');
      tempArray.push(tempItem);
    }
    this.commonService.exportAsExcelFile(tempArray, header, 'Clinic_Repayment');
    // this.commonService.exportTemplateAsExcel(tempArray, header);
  }
}
